const AssignedToMeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#D7FFEB" />
      <path
        d="M17.6668 13.0834C17.6668 10.7822 15.8013 8.91675 13.5002 8.91675C11.199 8.91675 9.3335 10.7822 9.3335 13.0834C9.3335 15.3846 11.199 17.2501 13.5002 17.2501C15.8013 17.2501 17.6668 15.3846 17.6668 13.0834Z"
        stroke="#11A75C"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.3332 23.0833C19.3332 19.8617 16.7215 17.25 13.4998 17.25C10.2782 17.25 7.6665 19.8617 7.6665 23.0833"
        stroke="#11A75C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.3335 16.3274C19.3335 16.3274 20.3335 16.8706 20.8335 17.6667C20.8335 17.6667 22.3335 14.5417 24.3335 13.5"
        stroke="#11A75C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default AssignedToMeIcon;
